<template>
  <div class="app-notification-container container">
    <TransitionGroup name="app-notification-container__transition">
      <AppNotification
        v-for="notification in appNotifications.notifications"
        :key="notification.id"
        :variant="notification.variant"
        :actions="notification.actions"
        @close="appNotifications.dismiss(notification.id)"
      >
        <template v-slot:title>{{ notification.title }}</template>
        <template v-slot:message>{{ notification.message }}</template>
      </AppNotification>
    </TransitionGroup>
  </div>
</template>

<script setup lang="ts">
import { appNotifications } from '@/services/notification.app'
import AppNotification from '@/app/components/AppNotification.vue'
</script>

<style lang="scss" scoped>
.app-notification-container {
  position: fixed;
  left: 0;
  right: 0;
  top: 92px;
  z-index: 201;
  display: grid;
  gap: 10px;

  @media only screen and (max-width: $w-tablet-s) {
    top: 65px;
  }

  &__transition {
    &-enter {
      &-active {
        transition:
          opacity 0.3s linear(0, 0.7 15%, 1.05 33%, 1.1 50%, 1),
          transform 0.3s linear(0, 0.7 15%, 1.05 33%, 1.1 50%, 1);
      }

      &-from {
        transform: translateY(-100px);
        opacity: 0.5;
      }

      &-to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    &-leave {
      &-active {
        width: calc(100% - var(--container-padding) * 2);
        margin-inline: var(--container-padding);
        position: absolute;
      }

      &-from {
        opacity: 1;
      }

      &-to {
        opacity: 0;
      }
    }

    &-leave-active,
    &-move {
      transition:
        opacity 0.3s,
        transform 0.3s;
      z-index: -1;
    }
  }
}
</style>
